export default __webpack_public_path__ + "static/media/uplaod.2ad5254c.svg";